import React, { useReducer, useState } from "react";
import Header from "../../Header";
import PromoNavPanel from "./PromoNavPanel";
import {
  Container,
  Alert,
  Form,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  FormText,
  CustomInput,
  Button,
} from "reactstrap";
import { PROMOCODE_APIS } from "../../../Constants/endpoints";
import { getToken } from "../../../Functions/userAuth";
import { errorToast, successToast } from "../../../Containers/toastFunctions";
import { ToastContainer } from "react-toastify";
import { URL } from "../../../config";

const CreateCampaign = () => {
  const [alertVisible, setAlertVisible] = useState(true);
  const [isLoading, setLoading] = useState(false);
  const reducer = (state, newState) => ({ ...state, ...newState });
  const [campaignData, setCampaignData] = useReducer(reducer, {
    name: "",
    expiry: "",
    description: "",
  });

  const onDismiss = () => {
    setAlertVisible(false);
  };

  const handleCreateCampaign = (e) => {
    e.preventDefault();
    setLoading(true);
    fetch(PROMOCODE_APIS._createCampaign, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${getToken("token")}`,
        "Ocp-Apim-Subscription-Key": URL.bidding_ocp_key,
      },
      body: JSON.stringify(campaignData),
    })
      .then((response) => response.json())
      .then(async (res) => {
        setLoading(false);
        if (res && res.success) {
          successToast(res?.message);
        } else {
          errorToast(res?.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        errorToast("Something went wrong!");
      });
  };

  const onChange = (e) => {
    let { name, value } = e.target;

    setCampaignData({ [name]: value });
  };

  return (
    <>
      <Header type="mainHeader" headerText="Create New Campaign" />
      <div className="promocode-campaign">
        <PromoNavPanel />
        <Container style={{ marginTop: "10px" }}>
          <Alert color="info" isOpen={alertVisible} toggle={onDismiss}>
            All <span className="required">*</span> fields are mandatory. To
            Create a New Promocode Campaign, Please fill all the details.
          </Alert>
          <Form
            onSubmit={handleCreateCampaign}
            style={{
              border: "1px solid gainsboro",
              borderRadius: "5px",
              padding: "20px",
              margin: "10px",
            }}
          >
            <Row form>
              <Col md={12}>
                <FormGroup>
                  <Label for="name">
                    Campaign Name<span className="required">*</span>
                  </Label>
                  <Input
                    type="text"
                    name="name"
                    id="name"
                    placeholder="Enter Campaign Name"
                    required
                    maxlength="25"
                    onChange={onChange}
                  />
                  <FormText>Limit the text to maximum 25 characters.</FormText>
                </FormGroup>
              </Col>
            </Row>
            <Row form>
              <Col md={12}>
                <FormGroup>
                  <Label for="expiry">
                    Campaign Expiry<span className="required">*</span>
                  </Label>
                  <Input
                    type="datetime-local"
                    name="expiry"
                    id="expiry"
                    placeholder="Enter Campaign Expiry"
                    required
                    onChange={onChange}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row form>
              <Col md={12}>
                <FormGroup>
                  <Label for="description">Campaign Description</Label>
                  <Input
                    type="textarea"
                    name="description"
                    id="description"
                    placeholder="Enter Campaign Description"
                    maxlength="100"
                    onChange={onChange}
                  />
                  <FormText>Limit the text to maximum 100 characters.</FormText>
                </FormGroup>
              </Col>
            </Row>
            <Button color="primary" disabled={isLoading}>
              Submit
            </Button>
          </Form>
        </Container>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
      />
    </>
  );
};

export default CreateCampaign;
